import type { RouteRecordRaw } from 'vue-router'

// Home 模块子页 + 添加设备引导
export const homeRoutes: RouteRecordRaw[] = [
  {
    path: '/home/map',
    name: 'home-map',
    component: () => import('@/pages/Home/Map/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/home/switch-device',
    name: 'home-switch-device',
    component: () => import('@/pages/Home/SwitchDevice/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/home/device-manage',
    name: 'home-device-manage',
    component: () => import('@/pages/Home/DeviceManage/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/home/device-manage/switch-sub-account',
    name: 'home-device-manage-switch-sub-account',
    component: () => import('@/pages/Home/DeviceManage/SwitchSubAccount/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/home/device-manage/wake-up',
    name: 'home-device-manage-wake-up',
    component: () => import('@/pages/Home/DeviceManage/WakeUp/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    // 海外流量套餐（URL 支付）
    path: '/home/traffic-zone/overseas',
    name: 'home-traffic-zone-overseas',
    component: () => import('@/pages/Home/TrafficZone/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    // 消息聊天页（对方 subUserId 入参，query.nickName 导航栏昵称）
    path: '/home/chat/:subUserId',
    name: 'home-chat',
    component: () => import('@/pages/Home/Chat/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    // 添加设备引导（Home 设备接口返回 2033 时跳转）
    path: '/guide',
    name: 'guide',
    component: () => import('@/pages/Guide/index.vue'),
    meta: { backMode: 'exit' },
  },
]
